import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import promise from 'redux-promise';
import { applyMiddleware, compose, createStore } from 'redux';
import * as microsoftTeams from "@microsoft/teams-js";
import { BrowserRouter as Router } from 'react-router-dom';
import { isSupported } from 'helpers/localstorage';
import sniffer from 'sniffer';
import jsonMiddleware from './middleware/parseJson';
import reducers from './reducers';
import Routes from './routes/index';
import AuthenticationProvider from 'components/Providers/AuthenticationProvider';
import LocalizationProvider from 'components/Providers/LocalizationProvider';
import CookiesNotSupportedError from 'containers/Errors/CookiesNotSupported';
import './helpers/polyfills'; // Import main stylesheet for app

import 'assets/css/main.scss';

function reduxMulti(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      return Array.isArray(action) ? action.filter(Boolean).map(dispatch) : next(action);
    };
  };
}

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var store = createStore(reducers, composeEnhancers(applyMiddleware(promise, jsonMiddleware, reduxMulti)));
sniffer.addClasses(document.documentElement);
var rootElement = document.querySelector('#root');

function Index() {
  microsoftTeams.app.initialize().then(function () {
    microsoftTeams.app.notifyAppLoaded();
  });
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(LocalizationProvider, null, /*#__PURE__*/React.createElement(AuthenticationProvider, null, /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Routes, {
    store: store
  })))));
}

if (isSupported()) {
  ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), rootElement);
} else {
  ReactDOM.render( /*#__PURE__*/React.createElement(CookiesNotSupportedError, null), rootElement);
}

function isIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

if (isIframe()) {
  document.querySelector('body').classList.add('is-frame');
}

export default store;